/**
 * Registro de textos fijos del front traducibles (reunión de traducciones del 14/10/2026).
 *
 * - La CLAVE es `<pantalla>.<elemento>`, en minúsculas y con guion bajo. Es la que se graba en el
 *   back (`Idiomas/grabar`, ámbito `ui`) y la que devuelve `Idiomas/diccionario` como `ui.<clave>`.
 * - El VALOR es el texto por defecto, en el idioma origen del congreso (castellano). Vive aquí, en
 *   el código, nunca en la base de datos: si nadie traduce nada, la web se ve igual que siempre.
 * - Los marcadores `{nombre}` se sustituyen con los parámetros del pipe: `'cesta.plazas' | t:{ n: 3 }`.
 *
 * Solo se traduce la parte del usuario final (web pública, inscripción, cesta, pago, zona privada).
 * Administración y Secretaría no van aquí.
 *
 * Este fichero es también el INVENTARIO que usará la pantalla global de traducciones para listar
 * todas las claves, incluidas las que aún nadie ha traducido. Añade aquí la clave antes de usarla.
 */
export const TEXTOS_UI = {
   // ----- Comunes -----
   'comun.aceptar': 'Aceptar',
   'comun.acomp_apellidos': 'Apellidos *',
   'comun.acomp_falta_cuota': 'Para inscribir acompañantes hace falta además una cuota de asistente.',
   'comun.acomp_nombre': 'Nombre acompañante *',
   'comun.acompanantes': 'Acompañantes',
   'comun.agotado': 'Agotado',
   'comun.anterior': 'Anterior',
   'comun.cancelar': 'Cancelar',
   'comun.cargando': 'Cargando…',
   'comun.cerrar': 'Cerrar',
   'comun.continuar': 'Continuar',
   'comun.editar': 'Editar',
   'comun.guardar': 'Guardar',
   'comun.no': 'No',
   'comun.pestana_nueva': 'Se abre en una pestaña nueva',
   'comun.quitar': 'Quitar',
   'comun.reintentar': 'Reintentar',
   'comun.selecciona': 'Selecciona…',
   'comun.si': 'Sí',
   'comun.siguiente': 'Siguiente',
   'comun.subtotal': 'Subtotal',
   'comun.total': 'Total',
   'comun.usar_mis_datos': 'Usar mis datos',
   'comun.ver_inscripciones': 'Ver mis inscripciones',
   'comun.volver': 'Volver',
   // ----- Wizard de inscripción (pages/inscripcion) -----
   'inscripcion.acompanante': 'Acompañante:',
   'inscripcion.anadir_congresista': 'Añadir otro congresista',
   'inscripcion.anadir_inscripcion': 'Añadir nueva inscripción',
   'inscripcion.archivo_proximamente': 'La subida de archivos estará disponible próximamente.',
   'inscripcion.campo_apellidos': 'Apellidos',
   'inscripcion.campo_dni': 'DNI',
   'inscripcion.campo_email': 'Email',
   'inscripcion.campo_nombre': 'Nombre',
   'inscripcion.cargando_catalogo': 'Cargando catálogo…',
   'inscripcion.cesta_vacia': 'No hay ninguna inscripción en la cesta.',
   'inscripcion.compra_ya_registrada': 'Tu compra anterior ya quedó registrada. Puedes consultar sus referencias en Mis inscripciones; aquí se ha iniciado una cesta nueva.',
   'inscripcion.cuota_titulo': 'Cuota de inscripción',
   'inscripcion.datos_lead': 'Aparecerán en el certificado y la acreditación.',
   'inscripcion.datos_titulo': 'Datos del congresista',
   'inscripcion.err_campos_formulario': 'No se pudieron cargar los campos adicionales del formulario.',
   'inscripcion.err_cesta_estado': 'La cesta ha cambiado de estado y ya no se puede confirmar. Se ha iniciado una nueva.',
   'inscripcion.err_cesta_invalida': 'No hay una cesta válida que se pueda sincronizar. Recarga la página e inténtalo de nuevo.',
   'inscripcion.err_cuota': 'Selecciona al menos una cuota para continuar.',
   'inscripcion.err_cuota_antes_anadir': 'Selecciona al menos una cuota antes de añadir otra inscripción.',
   'inscripcion.err_dni_formato': 'El DNI o NIE no tiene un formato válido.',
   'inscripcion.err_email_dni': 'Email y DNI son obligatorios para identificar al congresista.',
   'inscripcion.err_email_formato': 'El email no tiene un formato válido.',
   'inscripcion.err_ficha_sin_ref': 'La búsqueda encontró una ficha sin referencia válida.',
   'inscripcion.err_identidad_cambio': 'Los datos de identidad cambiaron durante la comprobación. Pulsa «Siguiente» de nuevo.',
   'inscripcion.err_identidad_comprobar': 'No se pudo comprobar la identidad. Inténtalo de nuevo.',
   'inscripcion.err_identidad_cuenta': 'El email o DNI no coincide con la referencia de tu cuenta. Revisa los datos antes de continuar.',
   'inscripcion.err_identidad_existente': 'No se pudo comprobar si ya existe una inscripción con estos datos. No se ha continuado.',
   'inscripcion.err_nombre': 'Nombre y apellidos son obligatorios.',
   'inscripcion.err_reservas': 'Revisa los avisos: hay elementos de la cesta que no se han podido reservar.',
   'inscripcion.err_rgpd': 'Debes aceptar la política de privacidad para continuar.',
   'inscripcion.err_sin_referencia': 'No se pudo confirmar una referencia de inscripción. Contacta con organización.',
   'inscripcion.err_telefono': 'El teléfono no es válido para el país seleccionado.',
   'inscripcion.error_catalogo': 'No se pudo cargar el catálogo. Comprueba tu conexión.',
   'inscripcion.error_catalogo_corto': 'No se pudo cargar el catálogo.',
   'inscripcion.inscribiendo_a': 'Inscribiendo a:',
   'inscripcion.mantener_reserva': 'Mantener reserva',
   'inscripcion.paso_datos': 'Datos',
   'inscripcion.paso_pago': 'Pago',
   'inscripcion.paso_resumen': 'Resumen',
   'inscripcion.paso_seleccion': 'Selección',
   'inscripcion.posicion': '{n} de {total}',
   'inscripcion.progreso': 'Progreso de la inscripción',
   'inscripcion.reactivar_reserva': 'Reactivar reserva',
   'inscripcion.rescatar': '¿Rescatamos tus datos del registro?',
   'inscripcion.reserva_caduca': 'Tu reserva de plazas caduca en',
   'inscripcion.reserva_caducada': 'Tu reserva de plazas ha caducado. Puedes reactivarla si sigue habiendo disponibilidad.',
   'inscripcion.resumen_lead': 'Revisa las inscripciones antes de continuar con el pago.',
   'inscripcion.resumen_titulo': 'Resumen de la cesta',
   'inscripcion.rgpd_antes': 'He leído y acepto la',
   'inscripcion.rgpd_despues': 'y el tratamiento de mis datos.',
   'inscripcion.rgpd_politica': 'política de privacidad',
   'inscripcion.seleccion_lead': 'Selecciona tu cuota y añade los servicios que quieras.',
   'inscripcion.seleccion_titulo': 'Elige tu inscripción',
   'inscripcion.servicios_titulo': 'Servicios disponibles según cuotas seleccionadas',
   'inscripcion.titular': 'Titular',
   'inscripcion.titulo': 'Inscripción',
   'inscripcion.titulo_defecto': 'Inscripción al congreso',
   'inscripcion.volver_mi_area': 'Volver a Mi Área',
   // ----- Panel de cuotas -----
   'cuotas.acomp_hint': 'Esta cuota es para acompañantes. Indica quiénes son (mínimo uno).',
   'cuotas.codigo': 'Código',
   'cuotas.mas_info': 'Más información sobre la cuota',
   'cuotas.seleccionada': 'Seleccionada',
   // ----- Panel de servicios -----
   'servicios.acomp_hint': 'Este servicio es para acompañantes. Indica quiénes son (mínimo uno).',
   'servicios.elige_opcion': 'Elige una opción',
   'servicios.excluyente': 'Excluyente',
   'servicios.mas_info': 'Más información sobre el servicio',
   'servicios.requiere_codigo': 'Requiere código',
   // ----- Facturación y pago (pago-panel) -----
   'pago.aviso_transferencia': 'Al confirmar recibirás las instrucciones de la transferencia. Tu inscripción quedará <b>pendiente de confirmación</b> hasta recibir el pago.',
   'pago.campo_factcp': 'Código postal',
   'pago.campo_factdir': 'Dirección',
   'pago.campo_factemail': 'Email de facturación',
   'pago.campo_factnif': 'NIF / CIF',
   'pago.campo_factnombre': 'Nombre o razón social',
   'pago.campo_factpob': 'Población',
   'pago.campo_factprov': 'Provincia',
   'pago.campo_facttel': 'Teléfono',
   'pago.comprobando_nif': 'Comprobando el NIF/CIF…',
   'pago.confirmando': 'Confirmando…',
   'pago.confirmar': 'Confirmar inscripción',
   'pago.detalle_paypal': 'Pago inmediato con tu cuenta de PayPal.',
   'pago.detalle_tarjeta': 'Pago inmediato con tarjeta a través de la pasarela segura.',
   'pago.detalle_transferencia': 'La inscripción queda pendiente hasta que la secretaría confirme el pago.',
   'pago.err_abrir': 'No se ha podido abrir la página de pago. Inténtalo de nuevo o elige otra forma de pago.',
   'pago.err_compra': 'No se pudo completar la compra. Revisa la cesta e inténtalo de nuevo.',
   'pago.err_compra_conserva': 'No se pudo completar la compra. La cesta se conserva para reintentar.',
   'pago.err_email': 'El email de facturación no es válido.',
   'pago.err_forma': 'Selecciona una forma de pago.',
   'pago.err_longitud': '"{campo}" supera los {max} caracteres.',
   'pago.err_nif': 'El NIF/CIF de facturación no es válido.',
   'pago.err_obligatorio': 'El campo "{campo}" es obligatorio.',
   'pago.err_plazas': 'Las plazas se agotaron antes de completar la compra.',
   'pago.err_sin_formas': 'Este congreso no tiene formas de pago configuradas. Contacta con la secretaría.',
   'pago.factura': 'Factura',
   'pago.factura_conjunta': 'Una única factura conjunta',
   'pago.factura_separada': 'Una factura por congresista',
   'pago.facturacion': 'Datos de facturación',
   'pago.forma_pago': 'Forma de pago',
   'pago.instrucciones_defecto': 'Realiza la transferencia por el importe total indicando en el concepto la referencia de pago. Si no tienes los datos bancarios, contacta con la secretaría del congreso.',
   'pago.instrucciones_titulo': 'Instrucciones de pago',
   'pago.lead': 'Último paso: datos de facturación y forma de pago.',
   'pago.mismos_datos': 'Mismos datos que el congresista',
   'pago.pagador_registrado': 'Pagador ya registrado:',
   'pago.pagador_registrado_detalle': 'Se facturará con los datos que constan para este NIF/CIF.',
   'pago.pagar': 'Pagar',
   'pago.pasarela': 'Pasarela de pago',
   'pago.preparando': 'Preparando el pago…',
   'pago.realizado_lead': 'Tu inscripción ha quedado confirmada.',
   'pago.realizado_titulo': 'Pago realizado',
   'pago.redirigiendo': 'Te estamos llevando a la página de pago segura. No cierres esta ventana.',
   'pago.referencia': 'Referencia de pago',
   'pago.referencia_concepto': 'Indícala en el concepto de la transferencia.',
   'pago.referencia_inscripcion': 'Referencia de tu inscripción',
   'pago.referencias_inscripciones': 'Referencias de tus inscripciones',
   'pago.sin_formas': 'Este congreso no tiene formas de pago configuradas todavía. Contacta con la secretaría.',
   'pago.titulo': 'Facturación y pago',
   'pago.transferencia_lead': 'Hemos registrado tu inscripción. Quedará <b>pendiente de confirmación</b> hasta que la secretaría verifique la recepción de la transferencia.',
   'pago.transferencia_titulo': 'Inscripción registrada — pendiente de confirmación',
   'pago.usar_otro_nif': 'Usar otro NIF',
   'pago.ya_confirmada': 'Tu inscripción ya constaba como registrada de un intento anterior, así que no se ha vuelto a enviar. Puedes consultar sus referencias en <b>Mis inscripciones</b>.',
   // ----- Vuelta de la pasarela (pago-retorno) -----
   'retorno.cancelado_lead': 'Has cancelado el pago en la pasarela y no se ha realizado ningún cargo. Tu selección sigue guardada.',
   'retorno.cancelado_titulo': 'Pago cancelado',
   'retorno.cancelar_compra': 'Cancelar la compra',
   'retorno.compra_intento': 'Compra nº {compra} · intento {intento}',
   'retorno.comprobar': 'Comprobar de nuevo',
   'retorno.confirmada_lead': 'Tu pago se ha recibido y la inscripción ha quedado <b>confirmada</b>. Puedes consultarla en <b>Mis inscripciones</b>.',
   'retorno.confirmada_titulo': 'Pago realizado',
   'retorno.consultando_lead': 'Estamos esperando la confirmación de la pasarela de pago. No cierres esta ventana; suele tardar unos segundos.',
   'retorno.consultando_titulo': 'Estamos confirmando tu pago…',
   'retorno.continuar_detalle': 'Puedes reintentar el pago o cancelar la compra para empezar una inscripción nueva (por ejemplo, para elegir otra forma de pago).',
   'retorno.err_abrir_pago': 'No se ha podido abrir la página de pago. Inténtalo de nuevo en unos segundos.',
   'retorno.err_cancelar': 'No se ha podido cancelar la compra. Inténtalo de nuevo en unos segundos.',
   'retorno.err_consultar': 'No hemos podido consultar el estado del pago. Inténtalo de nuevo en unos segundos.',
   'retorno.err_identificar': 'No hemos podido identificar la compra a la que corresponde este pago.',
   'retorno.err_iniciar_pago': 'No se ha podido iniciar el pago. Inténtalo de nuevo en unos segundos.',
   'retorno.err_no_existe': 'Esta compra no existe o no pertenece a tu sesión.',
   'retorno.error_titulo': 'No hemos podido comprobar el pago',
   'retorno.esperando_lead': 'La pasarela aún no nos ha comunicado el resultado. <b>Si has pagado, no repitas el pago:</b> la inscripción quedará confirmada automáticamente en los próximos minutos. Si saliste de la página de pago sin llegar a pagar, puedes intentarlo de nuevo.',
   'retorno.esperando_titulo': 'Todavía no tenemos la confirmación del pago',
   'retorno.no_completado_titulo': 'El pago no se ha completado',
   'retorno.no_pagable_lead': 'La compra ha caducado o fue anulada antes de completarse el pago. Si crees que se ha realizado un cargo, contacta con la secretaría del congreso indicando el nº de compra {compra}.',
   'retorno.no_pagable_titulo': 'Esta compra ya no se puede pagar',
   'retorno.no_pague_reintentar': 'No llegué a pagar: reintentar',
   'retorno.no_repitas': 'No repitas el pago.',
   'retorno.nueva_inscripcion': 'Nueva inscripción',
   'retorno.pendiente_detalle': 'La secretaría lo revisará; puedes comprobar el estado más tarde.',
   'retorno.pendiente_lead': 'Hemos recibido tu pago, pero no hemos podido cerrar la inscripción',
   'retorno.pendiente_titulo': 'Pago recibido, inscripción pendiente de completar',
   'retorno.referencia': 'Referencia de pago',
   'retorno.reintentar_pago': 'Reintentar el pago',
   'retorno.sin_cargo': 'No se ha realizado ningún cargo. Tu selección sigue guardada.',
   'retorno.volver_pago': 'Volver al pago',

   // ----- Landing pública -----
   'landing.zona_login': 'Zona de login / registro',
   'landing.secretaria_titulo': 'Secretaría Técnica',
   'landing.patrocinadores_titulo': 'Patrocinadores',
   'landing.imagen_congreso': 'Imagen del congreso',
   'landing.inicio_congreso': 'Inicio del congreso',
   'landing.acciones_superiores': 'Acciones superiores',
   'landing.informacion_legal': 'Información legal',

   // Accesibilidad y controles de la landing
   'landing.logo_congreso': 'Logo del congreso',
   'landing.seleccion_idioma': 'Selección de idioma',
   'landing.modo_claro': 'Modo claro',
   'landing.modo_oscuro': 'Modo oscuro',
   'landing.activar_modo_claro': 'Activar modo claro',
   'landing.activar_modo_oscuro': 'Activar modo oscuro',

   // ----- Acceso, login y registro -----
   'acceso.email_titulo': 'Accede a tu inscripción',
   'acceso.email_subtitulo': 'Introduce tu correo electrónico para acceder o iniciar una nueva inscripción.',
   'acceso.usuario_email': 'Usuario / email',
   'acceso.boton_continuar': 'Entrar',

   'acceso.password_titulo': 'Introduce tu contraseña',
   'acceso.password_subtitulo': 'Hemos reconocido tu correo. Escribe tu contraseña para entrar.',
   'acceso.password_label': 'Contraseña',
   'acceso.mostrar_password': 'Mostrar',
   'acceso.ocultar_password': 'Ocultar',
   'acceso.mostrar_password_aria': 'Mostrar contraseña',
   'acceso.ocultar_password_aria': 'Ocultar contraseña',
   'acceso.olvido_password': 'Olvidé mi contraseña',
   'acceso.boton_login': 'Entrar',
   'acceso.boton_volver': 'Volver',

   'acceso.registro_titulo': 'Crear cuenta',
   'acceso.registro_subtitulo': 'No encontramos tu correo. Completa tus datos para iniciar una nueva inscripción.',
   'acceso.registro_boton': 'Crear cuenta',
   'acceso.correo_label': 'Correo electrónico',
   'acceso.nombre_label': 'Nombre',
   'acceso.nombre_placeholder': 'Tu nombre',
   'acceso.apellidos_label': 'Apellidos',
   'acceso.apellidos_placeholder': 'Tus apellidos',
   'acceso.telefono_label': 'Teléfono',

   'acceso.recover_titulo': 'Recuperar contraseña',
   'acceso.recover_subtitulo': 'Introduce tu correo y te enviaremos un enlace para restablecer tu contraseña.',
   'acceso.recover_enviar': 'Enviar instrucciones',

   'acceso.reset_comprobando': 'Comprobando el enlace…',
   'acceso.reset_invalido': 'Enlace no válido',
   'acceso.reset_volver': 'Volver al login',
   'acceso.reset_ok': 'Contraseña actualizada',
   'acceso.reset_ok_descripcion': 'Ya puedes iniciar sesión con tu nueva contraseña.',
   'acceso.reset_ir_login': 'Ir al login',
   'acceso.reset_titulo': 'Escribe tu nueva contraseña',
   'acceso.reset_nueva': 'Nueva contraseña',
   'acceso.reset_repetir': 'Repite la contraseña',
   'acceso.reset_guardar': 'Guardar contraseña',
   // Mensajes de confirmación
   'acceso.recover_enviado': 'Si el correo está registrado, te hemos enviado un enlace para restablecer tu contraseña. Revisa tu bandeja de entrada.',
   'acceso.registro_email_enviado': 'Hemos enviado un email de confirmación a tu dirección. Haz clic en el enlace para activar tu cuenta.',
   'acceso.registro_creado': 'Tu cuenta ha sido creada. Ya puedes iniciar sesión.',
   // Errores de acceso y registro
   'acceso.error_email_comprobar': 'No se pudo comprobar el correo. Inténtalo de nuevo.',
   'acceso.error_password_no_coincide': 'Las contraseñas no coinciden.',
   'acceso.error_conexion': 'No se pudo conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.',
   'acceso.error_enlace': 'El enlace no es válido o ha caducado.',
   'acceso.error_credenciales': 'Usuario o contraseña incorrectos.',
   'acceso.error_sin_acceso': 'No tienes acceso a este congreso.',
   'acceso.error_login': 'No se pudo iniciar sesión.',
   'acceso.error_login_reintentar': 'No se pudo iniciar sesión. Inténtalo de nuevo.',
   'acceso.error_registro': 'No se pudo completar el registro. Revisa los datos e inténtalo de nuevo.',

   // Validaciones del formulario
   'acceso.validacion_nombre': 'Introduce tu nombre (mínimo 2 caracteres).',
   'acceso.validacion_apellidos': 'Introduce tus apellidos (mínimo 2 caracteres).',
   'acceso.validacion_telefono': 'Introduce un teléfono válido (mínimo 6 dígitos).',
   'acceso.validacion_password': 'La contraseña debe tener al menos 8 caracteres.',
   'acceso.validacion_email': 'El correo no tiene un formato válido.',
   'acceso.validacion_campos': 'Revisa los campos: todos son obligatorios.',


   // ----- Mi Área: navegación -----
   'mi_area.titulo': 'Mi área',
   'mi_area.mis_inscripciones': 'Mis inscripciones',
   'mi_area.datos_personales': 'Datos personales',

   // ----- Mi Área: listado de inscripciones -----
   'mi_area.listado_descripcion': 'Consulta de un vistazo las inscripciones que has realizado para ti o para otras personas.',
   'mi_area.nueva_inscripcion': 'Nueva inscripción',

   // Acordeón de inscripciones
   'mi_area.todas_inscripciones': 'Todas mis inscripciones',
   'mi_area.total_inscripciones': 'Total de inscripciones',
   'mi_area.ocultar_inscripciones': 'Ocultar inscripciones',
   'mi_area.mostrar_inscripciones': 'Mostrar inscripciones',

   // Estados del listado
   'mi_area.cargando_listado': 'Cargando listado de inscripciones',
   'mi_area.error_listado_titulo': 'No se han podido cargar las inscripciones',
   'mi_area.error_cargar_inscripciones': 'No hemos podido cargar tus inscripciones. Comprueba tu conexión e inténtalo de nuevo.',
   'mi_area.sin_inscripciones_titulo': 'Todavía no tienes inscripciones',
   'mi_area.sin_inscripciones_descripcion': 'Cuando completes una inscripción aparecerá aquí con su estado y sus conceptos asociados.',
   'mi_area.primera_inscripcion': 'Crear mi primera inscripción',

   // ----- Mi Área: inscripciones pendientes -----
   'mi_area.pendientes_titulo': 'Inscripciones pendientes de aceptarse',
   'mi_area.pendientes_contador': 'Inscripciones pendientes',
   'mi_area.ocultar_pendientes': 'Ocultar inscripciones pendientes',
   'mi_area.mostrar_pendientes': 'Mostrar inscripciones pendientes',
   'mi_area.pendientes_descripcion': 'Compras por transferencia pendientes de confirmación por Secretaría. Solo consulta.',
   'mi_area.sin_pendientes': 'No tienes inscripciones pendientes de aceptarse.',

   // ----- Mi Área: tabla de inscripciones -----

   // Cabeceras y columnas
   'mi_area.col_nombre': 'Nombre',
   'mi_area.col_congreso': 'Congreso',
   'mi_area.col_estado': 'Estado',
   'mi_area.col_cuotas': 'Cuotas',
   'mi_area.col_servicios': 'Servicios',
   'mi_area.col_importe': 'Importe',
   'mi_area.col_acciones': 'Acciones',
   'mi_area.inscripcion': 'Inscripción',
   'mi_area.importe_pendiente': 'Importe pendiente',

   // Valores vacíos o no disponibles
   'mi_area.fecha_no_disponible': 'Fecha no disponible',
   'mi_area.sin_cuotas_pendientes': 'Sin cuotas pendientes',
   'mi_area.sin_servicios_pendientes': 'Sin servicios pendientes',
   'mi_area.sin_cuotas_visibles': 'Sin cuotas visibles',
   'mi_area.sin_servicios_asociados': 'Sin servicios asociados',
   'mi_area.no_disponible': 'No disponible',

   // Acciones
   'mi_area.ver_detalle': 'Ver detalle',

   // ----- Mi Área: detalle de inscripción -----

   // Cabecera e información general
   'mi_area.detalle_titulo': 'Detalle de inscripción',
   'mi_area.cargando_detalle': 'Cargando detalle de inscripción',
   'mi_area.error_detalle_titulo': 'No se ha podido cargar la inscripción',
   'mi_area.fecha_inscripcion': 'Fecha de inscripción',
   'mi_area.cantidad': 'Cantidad',
   'mi_area.importe_no_disponible': 'Importe no disponible',

   // Cuotas
   'mi_area.cuota': 'Cuota',
   'mi_area.sin_cuotas_activas': 'Sin cuotas activas.',
   'mi_area.total_cuotas': 'Total cuotas',

   // Servicios y actividades
   'mi_area.servicios_actividades': 'Servicios y actividades',
   'mi_area.servicio_actividad': 'Servicio o actividad',
   'mi_area.sin_servicios_activos': 'Sin servicios activos.',
   'mi_area.total_servicios': 'Total servicios y actividades',

   // Acompañantes
   'mi_area.sin_acompanantes': 'Sin acompañantes.',
   'mi_area.total_acompanantes': 'Total acompañantes',

   // Totales y factura
   'mi_area.importe_total': 'Importe total',
   'mi_area.generar_factura': 'Generar factura',
   'mi_area.factura_no_disponible': 'La factura todavía no está disponible. Esta acción no realiza ninguna operación.',

   // ----- Mi Área: errores del detalle -----
   'mi_area.error_sin_referencia': 'No se ha indicado la referencia de la inscripción.',
   'mi_area.error_sin_permiso': 'No tienes permiso para consultar esta inscripción.',
   'mi_area.error_no_encontrada': 'No hemos encontrado una inscripción con esta referencia.',
   'mi_area.error_cargar_detalle': 'No hemos podido cargar el detalle de esta inscripción. Comprueba tu conexión e inténtalo de nuevo.',


   // ----- Mi Área: datos personales -----

   // Cabecera y carga
   'mi_area.datos_descripcion': 'Consulta y actualiza tus datos personales de la inscripción.',
   'mi_area.datos_error_carga_titulo': 'No se pudieron cargar tus datos',
   'mi_area.datos_volver_intentar': 'Volver a intentar',

   // Información personal
   'mi_area.datos_info_personal': 'Información personal',
   'mi_area.datos_info_personal_descripcion': 'Datos básicos de identificación y contacto.',
   'mi_area.datos_placeholder_nombre': 'Introduce tu nombre',
   'mi_area.datos_placeholder_apellidos': 'Introduce tus apellidos',

   // Dirección
   'mi_area.datos_direccion': 'Dirección',
   'mi_area.datos_direccion_descripcion': 'Información de residencia y contacto postal.',
   'mi_area.datos_pais': 'País',
   'mi_area.datos_placeholder_direccion': 'Calle, número, piso...',
   'mi_area.datos_placeholder_poblacion': 'Introduce tu población',
   'mi_area.datos_placeholder_provincia': 'Introduce tu provincia',
   'mi_area.datos_placeholder_pais': 'Introduce tu país',

   // Información de la cuenta
   'mi_area.datos_cuenta_titulo': 'Información de la cuenta',
   'mi_area.datos_cuenta_descripcion': 'Datos utilizados para acceder e identificar tu cuenta.',
   'mi_area.datos_email_aviso': 'Para cambiar tu email contacta con la organización.',
   'mi_area.datos_usuario_acceso': 'Usuario de acceso',
   'mi_area.datos_perfil': 'Perfil',

   // Seguridad y contraseña
   'mi_area.datos_seguridad': 'Seguridad',
   'mi_area.datos_seguridad_descripcion': 'Puedes guardar tus datos sin contraseña. Introduce la contraseña actual solo si deseas cambiarla.',
   'mi_area.datos_password_actual': 'Contraseña actual',
   'mi_area.datos_placeholder_password_actual': 'Introduce tu contraseña actual',
   'mi_area.datos_cambiar_password': 'Cambiar contraseña',
   'mi_area.datos_password_opcional': 'Opcional · Déjalo vacío para mantener tu contraseña actual.',
   'mi_area.datos_placeholder_password_nueva': 'Mínimo 6 caracteres',
   'mi_area.datos_repetir_password': 'Repetir nueva contraseña',
   'mi_area.datos_placeholder_repetir_password': 'Repite la nueva contraseña',
   'mi_area.datos_guardar_cambios': 'Guardar cambios',

   // Errores al cargar y guardar
   'mi_area.datos_error_usuario': 'No se pudo identificar al usuario del congreso actual.',
   'mi_area.datos_error_cargar': 'No se pudieron cargar los datos personales.',
   'mi_area.datos_error_guardar_titulo': 'No se pudieron guardar los datos',
   'mi_area.datos_error_campos_vacios': 'No se pueden dejar vacíos teléfonos o datos de dirección ya guardados. Introduce un valor para esos campos.',
   'mi_area.datos_error_guardar': 'Se produjo un error al guardar los datos personales.',
   'mi_area.datos_error_cambiar_password': 'No se pudo cambiar la contraseña.',
   'mi_area.datos_password_error_parcial': 'Datos guardados, pero la contraseña no se pudo cambiar',
   'mi_area.datos_error_password_actual': 'La contraseña actual no es correcta.',

   // Confirmaciones
   'mi_area.datos_guardados_titulo': 'Datos actualizados',
   'mi_area.datos_guardados_password': 'Tus datos y tu contraseña se han guardado correctamente.',
   'mi_area.datos_guardados': 'Tus datos personales se han guardado correctamente.',

   // Validaciones
   'mi_area.datos_validacion_nombre': 'El nombre es obligatorio.',
   'mi_area.datos_validacion_apellidos': 'Los apellidos son obligatorios.',
   'mi_area.datos_validacion_nif': 'El NIF o NIE no es válido.',
   'mi_area.datos_validacion_telefono': 'El número de teléfono no es válido.',
   'mi_area.datos_validacion_password_actual': 'Introduce tu contraseña actual para cambiarla.',
   'mi_area.datos_validacion_password_longitud': 'La nueva contraseña debe tener al menos 6 caracteres.',
   'mi_area.datos_validacion_password_incompleta': 'Completa y repite la nueva contraseña.',


} as const;

/** Clave registrada en TEXTOS_UI. */
export type ClaveUi = keyof typeof TEXTOS_UI;

/** Devuelve el texto por defecto de una clave, o la propia clave si no está registrada (para detectarlo a simple vista). */
export function textoPorDefecto(clave: string): string {
   return (TEXTOS_UI as Record<string, string>)[clave] ?? clave;
}

/** Prefijo de pantalla de una clave (`cesta.boton_pagar` → `cesta`). Lo usa la pantalla de traducciones para agrupar. */
export function pantallaDeClave(clave: string): string {
   return clave.split('.')[0] ?? '';
}
